
export const getExpertAvatar = (avatar_url: string | undefined) => {
  if (avatar_url) {
    return <img className='w-[46px] h-[46px] rounded-[23px] mr-[10px]' src={avatar_url} />
  } else {
    return <div className='bg-holifya-grey w-[46px] h-[46px] rounded-[23px] mr-[10px] flex items-center justify-center text-holifya-blue'>H</div>
  }
}